/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateOperatingCostInvoiceLineItemV1Dto = {
  /**
   * Area designation (Flächenbezeichnung)
   */
  areaDesignation: string;
  /**
   * name of the position. (Bezeichnung lt. Abrechnung)
   */
  nameOnStatement: string;
  /**
   * flat rate (Pauschale)
   */
  isFlatRate: boolean;
  /**
   * the total amount of the line item (Gesamtbetrag)
   */
  totalAmount?: number;
  /**
   * the customer amount, a share of the totalAmount (Betrag Kunde)
   */
  customerAmount?: number;
  /**
   * The total size of the area in square meters (Gesamtfläche)
   */
  totalArea?: number;
  /**
   * The customer size of the area in square meters (Kundenfläche)
   */
  customerArea?: number;
  status: CreateOperatingCostInvoiceLineItemV1Dto.status;
  /**
   * The unit of measurement for this line item.
   */
  unit?: CreateOperatingCostInvoiceLineItemV1Dto.unit;
  /**
   * SfmPosition ID (UUID v4) to link with this lineItem.
   */
  sfmPositionId: string;
  /**
   * Area ID (UUID v4) to link with this lineItem.
   */
  areaId?: string;
};
export namespace CreateOperatingCostInvoiceLineItemV1Dto {
  export enum status {
    CLEAR = 'Clear',
    UNCLEAR = 'Unclear',
  }
  /**
   * The unit of measurement for this line item.
   */
  export enum unit {
    SQUARE_METER = 'SquareMeter',
    CUBIC_METER = 'CubicMeter',
    KILOWATT_HOURS = 'KilowattHours',
    PIECE = 'Piece',
    DEGREE_DAYS = 'DegreeDays',
    PERCENT = 'Percent',
    KILOGRAM = 'Kilogram',
    HOURS = 'Hours',
  }
}
